import * as PropTypes from 'prop-types';

export interface CardBlockProps {
  title: string;
  content: string;
  iconSvg: string;
  delay: number;
}

export const CardBlockPropsType: React.ValidationMap<CardBlockProps> = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  iconSvg: PropTypes.string.isRequired,
  delay: PropTypes.number.isRequired
};
